export const CoupanCityConstant = {
  COUPAN_CITY_SAGA: "COUPAN_CITY_SAGA",
  COUPAN_CITY_REQUEST: "COUPAN_CITY_REQUEST",
  COUPAN_CITY_RESPONSE: "COUPAN_CITY_RESPONSE",
  COUPAN_CITY_API: "/all/coupons",

  POST_ADD_COUPAN_MODEL_SAGA: "POST_ADD_COUPAN_MODEL_SAGA",
  POST_ADD_COUPAN_MODEL_REQUEST: "POST_ADD_COUPAN_MODEL_REQUEST",
  POST_ADD_COUPAN_MODEL_RESPONSE: "POST_ADD_COUPAN_MODEL_RESPONSE",
  POST_ADD_COUPAN_MODEL_API: "/coupon",

  //delete api
  COUPAN_CITY_DELETE_SAGA: "COUPAN_CITY_DELETE_SAGA",
  COUPAN_CITY_DELETE_REQUEST: "COUPAN_CITY_DELETE_REQUEST",
  COUPAN_CITY_DELETE_RESPONSE: "COUPAN_CITY_DELETE_RESPONSE",
  COUPAN_CITY_DELETE_API: "/coupon/",

  CHARGING_NETWORK_DELETE_SAGA: "CHARGING_NETWORK_DELETE_SAGA",
  CHARGING_NETWORK_DELETE_REQUEST: "CHARGING_NETWORK_DELETE_REQUEST",
  CHARGING_NETWORK_DELETE_RESPONSE: "CHARGING_NETWORK_DELETE_RESPONSE",
  CHARGING_NETWORK_DELETE_API: "/coupon/",

  GET_SELECT_COUPON_CITY_SAGA: "GET_SELECT_COUPON_CITY_SAGA",
  GET_SELECT_COUPON_CITY_REQUEST: "GET_SELECT_COUPON_CITY_REQUEST",
  GET_SELECT_COUPON_CITY_RESPONSE: "GET_SELECT_COUPON_CITY_RESPONSE",
  GET_SELECT_COUPON_CITY_API: "/cities",

  GET_SELECT_CHARGING_NETWORK_SAGA: "GET_SELECT_CHARGING_NETWORK_SAGA",
  GET_SELECT_CHARGING_NETWORK_REQUEST: "GET_SELECT_CHARGING_NETWORK_REQUEST",
  GET_SELECT_CHARGING_NETWORK_RESPONSE: "GET_SELECT_CHARGING_NETWORK_RESPONSE",
  GET_SELECT_CHARGING_NETWORK_API: "/networks",
};
